import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { BarLoader } from 'react-spinners';
import { addToList } from '../actions';
import Check from '../img/check';
import ExtLink from '../img/extlink';
import * as selectors from '../selectors';

export default ({ artId, list }) => {
  const dispatch = useDispatch();
  const added = list.artworks && list.artworks.includes(parseInt(artId, 10));
  const adding = useSelector(selectors.addingToList)(list.id);
  return (
    <div
      className="fav__list-row"
      onClick={e => {
        e.preventDefault();
        !added && dispatch(addToList({ artId, listId: list.id }));
      }}
    >
      <div className="fav__list-added">
        {added && <Check />}
        {adding && <BarLoader color={'#212529'} />}
      </div>
      <p
        className={classNames('fav__list', {
          'fav__list--added': added,
        })}
      >
        {list.title.rendered}
        <a className="fav__list-link" href={list.link}>
          <ExtLink />
        </a>
      </p>
    </div>
  );
};
